
import { mixins, Options, Prop, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { UEFA_ACTION, UEFA_NAMESPACE, UefaPlayerStatPayload, UefaPlayerStatResult } from '../../store'

import UefaPlayerTable from '../components/uefa/UefaPlayerTable.vue'
import WidgetMixin, { WidgetMeta, widgetMetaFields } from './WidgetMixin'

export const meta: WidgetMeta = {
  label: 'UEFA - Játékosok',
  fields: {
    ...widgetMetaFields,
    length: {
      type: Number,
      default: 5,
      props: {
        placeholder: 'Darabszám',
        min: 2
      }
    }
  }
}

@Options({
  name: 'UefaPlayerStatWidget',
  components: {
    UefaPlayerTable
  }
})
export default class UefaPlayerStatWidget extends mixins(WidgetMixin) {
  @Action(UEFA_ACTION.PLAYER_STAT, { namespace: UEFA_NAMESPACE })
  storeFetchUefaPlayerStat!: (payload: UefaPlayerStatPayload) => Promise<UefaPlayerStatResult>

  @Prop({
    type: Number,
    default: 5
  })
  readonly length!: number

  get playerStat () {
    const types = {
      goals: 'total goals',
      assists: 'total assists',
      attempts: 'total attempt',
      saves: 'total saves',
      plays: 'total mins played'
    } as const

    const result: Record<Exclude<keyof typeof types, 'plays'>, { title: string, items: Array<{ name: string, team: string, value: number}>}> = {
      goals: { title: 'Gólok', items: [] },
      assists: { title: 'Gólpasszok', items: [] },
      attempts: { title: 'Kapura lövések', items: [] },
      saves: { title: 'Védések', items: [] }
    }

    const data = this.$store.getters['$cache/result']([UEFA_NAMESPACE, UEFA_ACTION.PLAYER_STAT], this.uefaPlayerStatPayload)?.data

    if (data) {
      const players = data.team.flatMap((team: any) => team.player.map((player: any) => {
        const item = {
          name: player.name,
          team: team.name,
          img: `${this.$store.getters.getEnv('RTL_URL') ?? ''}/uefa/players/${team.name.replace('/', '-')} - ${player.name.replace('/', '-')}.jpg`,
          goals: 0,
          assists: 0,
          attempts: 0,
          saves: 0,
          plays: 0
        }

        for (const key in types) {
          const type = types[key as keyof typeof types]
          item[key as keyof typeof types] = parseInt(player.stat.find((stat: any) => {
            return stat.type === type
          })?.value ?? 0)
        }
        return item
      }))

      for (const key in types) {
        if (key in result) {
          result[key as Exclude<keyof typeof types, 'plays'>].items = players.map((player: any) => {
            return { ...player, value: player[key] } 
          })
          .sort((a: any, b: any) => {
            switch (key) {
              case 'goals':
                return (b.goals - a.goals) || (a.plays - b.plays) || (b.assists - a.assists)
              case 'assists':
                return (b.assists - a.assists) || (a.plays - b.plays) || (b.goals - a.goals)
            }
            return b.value - a.value
          })
          .splice(0, this.length)
        }
      }
      return result
    }

    return result
  }

  get uefaPlayerStatPayload (): UefaPlayerStatPayload {
    return {}
  }

  @Watch('uefaPlayerStatPayload', { deep: true })
  async fetchUefaPlayerStat () {
    if (this.uefaPlayerStatPayload) {
      return this.storeFetchUefaPlayerStat(this.uefaPlayerStatPayload)
    }
  }

  serverPrefetch () {
    return this.fetchUefaPlayerStat()
  }

  mounted () {
    return this.fetchUefaPlayerStat()
  }
}
